import * as React from 'react';

import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
  useSidebar,
} from '@cotera/client/v0/components/ui/sidebar';
import { Datasets } from './datasets';
import { Footer } from './footer';
import { Header } from './header';
import { QuickFix } from './quickfix';
import { Definitions } from './definitions';
import { Documents } from './documents';
import { Agents } from './agents';
import { useMediaQuery } from '@cotera/client/app/hooks';

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  const { setOpenMobile } = useSidebar();
  const isSmallScreen = useMediaQuery('(max-width: 767px)');

  const handleSidebarItemClick = React.useCallback(
    (event: React.MouseEvent<HTMLDivElement>) => {
      if (!isSmallScreen) {
        return;
      }

      const target = event.target as HTMLElement | null;
      if (!target) {
        return;
      }

      // Don't close sidebar when interacting with dropdown menus
      const isDropdownTrigger = target.closest(
        '[data-slot="dropdown-menu-trigger"]'
      );
      if (isDropdownTrigger) {
        return;
      }

      const interactiveElement = target.closest(
        '[data-sidebar="menu-button"], [data-sidebar="menu-sub-button"], [data-sidebar="menu-action"]'
      );

      if (interactiveElement) {
        setOpenMobile(false);
      }
    },
    [isSmallScreen, setOpenMobile]
  );

  return (
    <Sidebar {...props}>
      <SidebarHeader
        className="border-b border-border"
        onClick={handleSidebarItemClick}
      >
        <Header />
      </SidebarHeader>
      <SidebarContent onClick={handleSidebarItemClick}>
        <QuickFix />
        <Datasets />
        <Agents />
        <Documents />
        <Definitions />
      </SidebarContent>
      <SidebarFooter
        className="border-t border-border"
        onClick={handleSidebarItemClick}
      >
        <Footer />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}
